module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/bulk-sms/bulk-sms.component.scss
// module id = ./src/app/routes/bulk-sms/bulk-sms.component.scss
// module chunks = 9